import { type ReactNode } from "react";
import { ScreenScaffold } from "./ScreenScaffold.tsx";

/**
 * The in-shell not-found screen. Every design-12.2 route now has its real module (tasks 11.4–11.15
 * are complete), so the only remaining placeholder is the fallback for an UNKNOWN route — it keeps
 * the chrome in place and explains, in the honest voice design 12.3 asks for, that there is no
 * screen at the address.
 */

/** The in-shell not-found for an unknown route. The chrome stays; only the content says so. */
export function NotFoundScreen(): ReactNode {
  return (
    <ScreenScaffold
      title="Not found"
      state={{ kind: "empty", cause: "There is no screen at this address. Use the navigation above." }}
    />
  );
}
